import { createFileRoute } from '@tanstack/react-router'

interface ConnectionSearch {
  page?: number
  sort?: string
  order?: 'asc' | 'desc'
  tab?: string
  actingTenantId?: string
  from?: 'books'
}

export const Route = createFileRoute('/integrations/connections/$id')({
  validateSearch: (search: Record<string, unknown>): ConnectionSearch => ({
    page:
      typeof search.page === 'number' && search.page > 1
        ? search.page
        : undefined,
    sort: typeof search.sort === 'string' ? search.sort : undefined,
    order:
      search.order === 'asc' || search.order === 'desc'
        ? search.order
        : undefined,
    tab: typeof search.tab === 'string' ? search.tab : undefined,
    actingTenantId:
      typeof search.actingTenantId === 'string'
        ? search.actingTenantId
        : undefined,
    from: search.from === 'books' ? ('books' as const) : undefined,
  }),
})
